import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import { AuthUser } from 'types/User';
import { createAccountWithEmailAndPassword } from 'lib/Auth';

export default async function createAccountByEmail(
  email: string,
  password: string
): Promise<AuthUser> {
  const credential = await createAccountWithEmailAndPassword(email, password);
  const data = extractDataFromFirebaseCredential(credential);

  return data;
}
